<template>
  
  <form class="mt-2">
    {{ setUser }}
    <div class="row">
      <div class="col-md-6">
        <!-- title input -->
        <div class="form-group">
          <label class="label-form">First Name<span style="color: red;">*</span>:</label>
          <input type="text" class="form-control" v-model="first_name" placeholder="First Name" />
        </div>
      </div>
      <div class="col-md-6">
        <!-- title input -->
        <div class="form-group">
          <label class="label-form">Last Name<span style="color: red;">*</span>:</label>
          <input type="text" class="form-control" v-model="last_name" placeholder="Last Name" />
        </div>
      </div>
      <div class="col-md-6">
        <!-- title input -->
        <div class="form-group">
          <label class="label-form">Username<span style="color: red">*</span>:</label>
          <input type="text" class="form-control" v-model="user_name" placeholder="Username" />
        </div>
      </div>
      <div class="col-md-6">
        <!-- title input -->
        <div class="form-group">
          <label class="label-form">Email<span style="color: red">*</span>:</label>
          <input type="text" class="form-control" v-model="email" placeholder="Email" />
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-12 col-md-6">
        <!-- title input -->
        <div class="form-group">
          <label class="label-form">User Type<span style="color: red">*</span>:</label>
          <select style="padding:7px 10px" v-model="role_id" @change="selectType" class="form-control"   placeholder="Select User Type">
            <option value=""></option>
            <option value=1 v-if=" $can('admin_users_update_usertype_admin')">Admin</option>
            <option value=2 v-if=" $can('admin_users_update_usertype_crm')" >CRM</option>
            <option value=3 v-if=" $can('admin_users_update_usertype_editor')">Editor</option>
            <option value=4 v-if=" $can('admin_users_update_usertype_support')">Support</option>
            <option value=5 v-if=" $can('admin_users_update_usertype_dataentry')">Data Entry</option>
            <option value=6 v-if=" $can('admin_users_update_usertype_marketing')">Digital Marketing</option>
            <option value=7 v-if=" $can('admin_users_update_usertype_adh')">ADH</option>
            <option value=8 v-if=" $can('admin_users_update_usertype_lead')">Development Lead</option>
            <option value=9 v-if=" $can('admin_users_update_usertype_developer')">Developer</option>
            <option value=10 v-if=" $can('admin_users_update_usertype_csm')">CSM</option>
            <option value=11 v-if=" $can('admin_users_update_usertype_adhhelper')">ADH Helper</option>
            <option value=12 v-if=" $can('admin_users_update_usertype_qa')">QA</option>
            <option value=13 v-if=" $can('admin_users_update_usertype_designer')">Designer</option>
          </select>
        </div>
      </div>
      <div class="col-sm-12 col-md-6" >
         <div class="form-group">
            <label  class="label-form">Software<span style="color: red">*</span>:</label>
              <multiselect @input="selectedProduct" :options="products" :multiple="true" :taggable="true" :close-on-select="false"
               :clear-on-select="false" :internal-search="false" :selectedLabel="null" :deselectLabel="null" :selectLabel="null" 
               :allow-empty="true" v-model="selected_product" label="name" track-by="id" style="font-size:12px !important">
              </multiselect>
        </div>
      </div>
      
    </div>
    <div class="row">
      <div  v-show="[7,8,9,11].includes(this.role_id) || show_team_field" class="col-sm-12 col-md-6" >
         <div class="form-group">
          <label   class="label-form">Team<span style="color: red">*</span>:</label>
              <multiselect  v-if="role==7" :options="teamsList" :multiple="true" :selectedLabel="null" :deselectLabel="null" :allow-empty="true"
                v-model="team" :selectLabel="null" :internal-search="true" label="name" track-by="id" placeholder="Team">
              </multiselect>
              <multiselect v-else :options="teamsList" :multiple="true" :selectedLabel="null" :deselectLabel="null" :allow-empty="true"
                v-model="team" :selectLabel="null" :internal-search="true" label="name" track-by="id" placeholder="Team">
              </multiselect>

             
        </div>
      </div>
    </div>
      <div v-if="set_zoom_credentials"  class="row">
        <div class="col-sm-12 col-md-6" >
            <div class="form-group">
              <label  class="label-form"> Zoom Client Id:</label>
              <input type="text" class="form-control" v-model="client_id" placeholder="Zoom Client Id" />
            </div>
        </div>
        <div class="col-sm-12 col-md-6" >
            <div class="form-group">
              <label  class="label-form"> Zoom Client Secret:</label>
              <input type="text" class="form-control" v-model="client_secret" placeholder="Zoom Client Secret" />
            </div>
        </div>
      </div>
    <div v-if="set_zoom_credentials"  class="row">
      <div class="col-sm-12 col-md-6" >
        <div class="form-group">
          <label  class="label-form"> Zoom Account Id:</label>
          <input type="text" class="form-control" v-model="account_id" placeholder="Zoom Account Id" />
        </div>
      </div>
    </div>
    <diV class="row">
      <div class="col-md-12">
        <!-- buttons -->
        <div class="form-footer text-right">
          <button type="button" class="btn btn-secondary" data-dismiss="modal">
            Close
          </button>
          <button type="button" class="btn btn-default ml-1" :style= "[isMiniLoading ? { 'cursor' : 'default' } : { 'cursor' : 'pointer' }]" :disabled="isMiniLoading" @click="save">
            <font-awesome-icon v-if="isMiniLoading" icon="spinner" style="animation: spin 2s linear infinite; float:right; margin-left: 5px; margin-top: 3px;" />
            Save
          </button>
        </div>
      </div>
    </diV>
  </form>
</template>
<script>
  import axios from "axios";
  import Multiselect from "vue-multiselect";
  export default {
    components: {
      Multiselect
    },
    props: ["action", "formData"],
    data: function () {
      return {
        selected: "",
        user: "",
        user_name: "",
        first_name: "",
        filter_team_id: "",
        last_name: "",
        email: "",
        role_id: "",
        products: '',
        selected_product: '',
        products_status: [],
        isMiniLoading:false,
        type: "",
        search: "",
        client_id: null,
        client_secret: null,
        account_id: null,
        set_zoom_credentials:false,
        show_team_field:false,
        teamsList:[],
        team:[],
        role: JSON.parse(localStorage.getItem("role")),
        userAssignedProduct :localStorage.getItem("user_product"),
      };
    },
    computed: {
     
      setUser: function () {
        this.user_name = this.formData.user_name;
        this.first_name = this.formData.first_name;
        this.last_name = this.formData.last_name;
        this.email = this.formData.email;
        this.role_id = this.formData.role_id;
        this.type = this.formData.selectedType;
        this.search = this.formData.search
        this.products = this.$store.getters['persist/availableProducts'];
        this.products = this.products.filter(product =>
         this.userAssignedProduct.includes(product.id)
        );
        this.set_zoom_credentials = (this.formData.role_id==4 || this.formData.role_id == 10) ? true :false;
        this.client_id = this.formData.client_id;
        this.client_secret = this.formData.client_secret;
        this.account_id = this.formData.account_id;
        this.team = this.formData.team;
        this.filter_team_id = this.formData.filter_team_id;
        this.teamsList = this.formData.teamsList;
      },
    },
    created: function () {
       this.selected_product = this.formData.product;
    },
    methods: {
      save() {
        this.isMiniLoading = true;
        let user_id = this.formData.user_id;
        let user_name = this.user_name;
        let usr_first_name = this.first_name;
        let usr_last_name = this.last_name;
        let usr_email = this.email;
        let usr_type = this.role_id;
        let teams =  this.team.length>0 ? this.team.map(({ id }) => id):[];
        if(this.products_status.length < 1 && this.selected_product.length > 0){
         this.selectedProduct();
        }
        let selected_product = this.products_status;
        if (
          user_name.replace(/\s/g, "").length &&
          usr_first_name.replace(/\s/g, "").length &&
          usr_last_name.replace(/\s/g, "").length &&
          usr_email.replace(/\s/g, "").length &&
          usr_type!='' && 
          selected_product.length && (([7,8,9,11].includes(usr_type) && teams.length > 0 )|| ![7,8,9,11].includes(usr_type))
        ) {
             const permission = {
      headers: {
        'X-Permission': 'admin_users_update' 
      }
    };
          axios.post("admin/users/update-admin-user", {
            id: user_id,
            user_name: user_name,
            first_name: usr_first_name,
            last_name: usr_last_name,
            email: usr_email,
            role_id: usr_type,
            product: selected_product,
            client_id: this.client_id,
            client_secret: this.client_secret,
            account_id:this.account_id,
            teams: teams,
          },permission)
            .then(() => {
              this.isMiniLoading = false;
              window.$("#modal").modal("hide");
              this.$store.dispatch('users/getAdminUsers',[this.search,this.type,this.filter_team_id]);
              // this.$store.dispatch("users/getadminusersBySearch", ["", this.formData.selectedType]);
              this.set_zoom_credentials = false;
              this.$toast.success('User Updated Successfully!');
            })
            .catch((error) => {
              this.isMiniLoading = false;
              let response = error.response.message;
              this.$toast.error(response);
            });
        } else {
          this.isMiniLoading = false;
          this.$toast.error('Please Fill Required Fields!');
        }
      },
      selectedProduct(){
        let product = [];
        if(this.selected_product.length){
          this.selected_product.forEach(key => {
           product.push(key.id)
        });
        }
        this.products_status = product;
      },
      selectType(){
        if(this.role_id != 7 && this. role_id != 8 && this.role_id != 9 && this. role_id != 11){
          this.team = [];
          this.show_team_field = false;
        }else{
          this.team = [];
          this.show_team_field = true;
        }
        if(this.role_id == 4 || this.role_id == 10) {
          this.set_zoom_credentials = true;
        }else{
          this.set_zoom_credentials = false;
          this.client_id = null;
          this.client_secret = null
          this.account_id = null;
        }
         
      }
    },
  };
</script>

<style scoped>
  span.error {
    display: block;
    color: red;
    margin-top: 5px;
  }

  .field {
    margin-top: 20px;
  }
</style>